import React, { useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Logo from './images/logo.png';
import './style/Navbar.scss';

const NavBar = () => {
    const [expanded, setExpanded] = useState(false); // Control navbar state

    return (
        <Navbar expanded={expanded} className="navbar navbar-expand-lg navbar-light" expand="lg" variant="light">
            <img src={Logo} alt="Logo" />
            <Navbar.Toggle onClick={() => setExpanded(expanded ? false : "expanded")} aria-controls="navbarTogglerDemo02" />

            <Navbar.Collapse id="navbarTogglerDemo02">
                <Nav className="navbar-nav ml-auto">
                    <Nav.Item className='item'>
                        <NavLink 
                            to="/" 
                            className="nav-link ab" 
                            style={{ color: 'white' }}
                            onClick={() => setExpanded(false)} // Closes menu on link click
                        >
                            <i className="fa fa-home" aria-hidden="true"></i> Home
                        </NavLink>
                    </Nav.Item>

                    <Nav.Item className='item'>
                        <NavLink 
                            to="/About" 
                            className="nav-link ab" 
                            style={{ color: 'white' }}
                            onClick={() => setExpanded(false)}
                        >
                            <i className="fa fa-user" aria-hidden="true"></i> About Me
                        </NavLink>
                    </Nav.Item>

                    <Nav.Item className='item'>
                        <NavLink 
                            to="/Contact" 
                            className="nav-link ab" 
                            style={{ color: 'white' }}
                            onClick={() => setExpanded(false)}
                        >
                            <i className="fa fa-phone" aria-hidden="true"></i> Contact
                        </NavLink>
                    </Nav.Item>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default NavBar;
